import { render, staticRenderFns } from "./AcctAdd.vue?vue&type=template&id=3b21bd02&scoped=true&"
import script from "./AcctAdd.vue?vue&type=script&lang=js&"
export * from "./AcctAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21bd02",
  null
  
)

export default component.exports